export const downloadFile = (data: Blob, fileName: string) => {
   const link = document.createElement('a');
   link.target = '_blank';
   link.download = fileName;
   link.href = URL.createObjectURL(data);
   link.click();
};

export const downloadTextFile = (text: string, filename: string) => {
   const fileData = text; //JSON.stringify(text);
   const blob = new Blob([fileData], {type: 'text/plain'});
   const url = URL.createObjectURL(blob);
   const link = document.createElement('a');
   link.download = filename;
   link.href = url;
   link.click();
};
